<svg
  [attr.width]="size()"
  [attr.height]="size()"
  viewBox="0 0 20 20"
  aria-hidden="true"
  focusable="false"
>
  <rect x="1" y="1" width="8.5" height="8.5" fill="#F25022" />
  <rect x="10.5" y="1" width="8.5" height="8.5" fill="#7FBA00" />
  <rect x="1" y="10.5" width="8.5" height="8.5" fill="#00A4EF" />
  <rect x="10.5" y="10.5" width="8.5" height="8.5" fill="#FFB900" />
</svg>
